import React from 'react';
import { useFetch } from '../context/FetchProvider';
import { SaleBanner } from '../types/saleBanner';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { useQuery } from 'react-query';
import { faBullhorn } from '@fortawesome/pro-solid-svg-icons/faBullhorn';
import { faClock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faGift } from '@fortawesome/pro-solid-svg-icons/faGift';
import { faGlobe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faMedkit } from '@fortawesome/pro-solid-svg-icons/faMedkit';
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faTrophy } from '@fortawesome/pro-solid-svg-icons/faTrophy';

// Icons are formatted by the backend as fa-<icon>
const formatIcon = (name?: string): string => {
  return name?.split('-').pop() || '';
};

const icons: { [index: string]: IconDefinition } = {
  gift: faGift,
  clock: faClock,
  trophy: faTrophy,
  medkit: faMedkit,
  bullhorn: faBullhorn,
  envelope: faEnvelope,
  globe: faGlobe,
  start: faStar,
};

/**
 * Hook for SaleBanner component.
 * Returned banner data, its parsed icon, variables to manage state, and trigger timeout function for expires date.
 */
export function useSaleBanner(): {
  saleBanner?: SaleBanner;
  icon?: IconDefinition;
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
} {
  const [isVisibleState, setIsVisible] = React.useState(true);
  const { get } = useFetch();

  const { data: saleBanner } = useQuery('saleBanner', async () => {
    const { data } = await get<{ saleBanner?: SaleBanner }>('/v0/salebanner');
    if (data?.saleBanner) {
      return data.saleBanner;
    }

    return undefined;
  });

  const icon = icons[formatIcon(saleBanner?.icon)];

  const isVisible = !!saleBanner && isVisibleState;

  return { saleBanner, icon, isVisible, setIsVisible };
}
